if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const variantInput = this.form.querySelector('[name="id"]');

        if (variantInput) {
          variantInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');

        if (!submitButton) return;

        if (submitButton.classList.contains('loading')) return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => {
                throw error;
              });
            }

            return response.json();
          })
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            const ricButton =
              this.querySelector('.ric-add-to-cart');

            if (ricButton) {
              ricButton.classList.remove('loading');
              ricButton.classList.add('ric-added');

              setTimeout(() => {
                ricButton.classList.remove('ric-added');
              }, 1200);
            }

            /*
             * Shopify successfully added the product.
             * This theme does not have a cart drawer or
             * cart-notification component, so go directly
             * to the Shopify cart page.
             */
            if (
              document.querySelector('cart-notification') &&
              typeof openCartDrawer === 'function'
            ) {
              const cartNotification =
                document.querySelector('cart-notification');

              if (typeof cartNotification.renderContents === 'function') {
                cartNotification.renderContents(response);
              }

              if (typeof openCartDrawer === 'function') {
                openCartDrawer();
              }
            } else {
              window.location.href =
                routes.cart_url || '/cart';
            }
          })
          .catch((error) => {
            console.error('Add to Cart Error:', error);

            this.handleErrorMessage(
              error.description ||
              error.message ||
              'Unable to add this product to the cart. Please try again.'
            );
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        if (!this.errorMessage) return;

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}